/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Tasks {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List Task Templates.
   *
   * @tags Tasks
   * @name ListTemplates
   * @summary List Templates
   * @request GET:/api/tasks/templates
   * @secure
   */
  listTemplates = (params = {}) =>
    this.http.request({
      path: `/api/tasks/templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Task Template.
   *
   * @tags Tasks
   * @name CreateTemplate
   * @summary Create Template
   * @request POST:/api/tasks/templates
   * @secure
   */
  createTemplate = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Task Template.
   *
   * @tags Tasks
   * @name GetTemplate
   * @summary Get Template
   * @request GET:/api/tasks/templates/{template_id}
   * @secure
   */
  getTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/tasks/templates/${templateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Task Template.
   *
   * @tags Tasks
   * @name UpdateTemplate
   * @summary Update Template
   * @request PUT:/api/tasks/templates/{template_id}
   * @secure
   */
  updateTemplate = (templateId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/templates/${templateId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Task Template.
   *
   * @tags Tasks
   * @name DeleteTemplate
   * @summary Delete Template
   * @request DELETE:/api/tasks/templates/{template_id}
   * @secure
   */
  deleteTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/tasks/templates/${templateId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Instantiate Task Template into a concrete Task.
   *
   * @tags Tasks
   * @name InstantiateTemplate
   * @summary Instantiate Template
   * @request POST:/api/tasks/templates/{template_id}/instantiate
   * @secure
   */
  instantiateTemplate = (templateId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/templates/${templateId}/instantiate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Inspect current stage gate readiness, required tasks, and blocker counts without mutating state.
   *
   * @tags Tasks
   * @name GetStageGatesReadiness
   * @summary Get Stage Gates Readiness
   * @request GET:/api/tasks/stage-gates
   * @secure
   */
  getStageGatesReadiness = (query, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Pre-flight validation evaluating stage gating checklist tasks before stage transition.
   *
   * @tags Tasks
   * @name ValidateStageTransition
   * @summary Validate Stage Transition
   * @request POST:/api/tasks/stage-gates/validate
   * @secure
   */
  validateStageTransition = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Manager/Owner bypass of blocking checklist gates with mandatory audit logging.
   *
   * @tags Tasks
   * @name BypassStageTransition
   * @summary Bypass Stage Transition
   * @request POST:/api/tasks/stage-gates/bypass
   * @secure
   */
  bypassStageTransition = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates/bypass`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a standardized checklist template for a workflow stage.
   *
   * @tags Tasks
   * @name CreateStageTemplate
   * @summary Create Stage Template
   * @request POST:/api/tasks/stage-gates/templates
   * @secure
   */
  createStageTemplate = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates/templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List stage checklist templates.
   *
   * @tags Tasks
   * @name ListStageTemplates
   * @summary List Stage Templates
   * @request GET:/api/tasks/stage-gates/templates
   * @secure
   */
  listStageTemplates = (query, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates/templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a stage checklist template.
   *
   * @tags Tasks
   * @name DeleteStageTemplate
   * @summary Delete Stage Template
   * @request DELETE:/api/tasks/stage-gates/templates/{template_id}
   * @secure
   */
  deleteStageTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates/templates/${templateId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create Task.
   *
   * @tags Tasks
   * @name CreateTask
   * @summary Create Task
   * @request POST:/api/tasks
   * @secure
   */
  createTask = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Tasks.
   *
   * @tags Tasks
   * @name ListTasks
   * @summary List Tasks
   * @request GET:/api/tasks
   * @secure
   */
  listTasks = (query, params = {}) =>
    this.http.request({
      path: `/api/tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Batch update, close, assign, or delete multiple tasks.
   *
   * @tags Tasks
   * @name BatchUpdateTasks
   * @summary Batch Update Tasks
   * @request POST:/api/tasks/batch
   * @secure
   */
  batchUpdateTasks = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Batch update, close, assign, or delete multiple tasks.
   *
   * @tags Tasks
   * @name BatchUpdateTasks2
   * @summary Batch Update Tasks
   * @request POST:/api/tasks/bulk-operation
   * @originalName batchUpdateTasks
   * @duplicate
   * @secure
   */
  batchUpdateTasks2 = (data, params = {}) =>
    this.http.request({
      path: `/api/tasks/bulk-operation`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate whether an individual task or parent stage can transition or if blocked.
   *
   * @tags Tasks
   * @name ValidateTaskTransition
   * @summary Validate Task Transition
   * @request POST:/api/tasks/{task_id}/validate-transition
   * @secure
   */
  validateTaskTransition = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/validate-transition`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all tasks for a parent entity grouped by stage_key.
   *
   * @tags Tasks
   * @name GetTasksByParentGrouped
   * @summary Get Tasks By Parent Grouped
   * @request GET:/api/tasks/by-parent/{parent_type}/{parent_id}
   * @secure
   */
  getTasksByParentGrouped = (parentType, parentId, params = {}) =>
    this.http.request({
      path: `/api/tasks/by-parent/${parentType}/${parentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Task by ID with assignees, activity logs, comments, and attachments enforcing tenant isolation.
   *
   * @tags Tasks
   * @name GetTask
   * @summary Get Task
   * @request GET:/api/tasks/{task_id}
   * @secure
   */
  getTask = (taskId, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Task.
   *
   * @tags Tasks
   * @name UpdateTask
   * @summary Update Task
   * @request PATCH:/api/tasks/{task_id}
   * @secure
   */
  updateTask = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update Task.
   *
   * @tags Tasks
   * @name UpdateTask2
   * @summary Update Task
   * @request PUT:/api/tasks/{task_id}
   * @originalName updateTask
   * @duplicate
   * @secure
   */
  updateTask2 = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Task.
   *
   * @tags Tasks
   * @name DeleteTask
   * @summary Delete Task
   * @request DELETE:/api/tasks/{task_id}
   * @secure
   */
  deleteTask = (taskId, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Add Comment.
   *
   * @tags Tasks
   * @name AddComment
   * @summary Add Comment
   * @request POST:/api/tasks/{task_id}/comments
   * @secure
   */
  addComment = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Comments.
   *
   * @tags Tasks
   * @name ListComments
   * @summary List Comments
   * @request GET:/api/tasks/{task_id}/comments
   * @secure
   */
  listComments = (taskId, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/comments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List Attachments.
   *
   * @tags Tasks
   * @name ListAttachments
   * @summary List Attachments
   * @request GET:/api/tasks/{task_id}/attachments
   * @secure
   */
  listAttachments = (taskId, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/attachments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add Attachment.
   *
   * @tags Tasks
   * @name AddAttachment
   * @summary Add Attachment
   * @request POST:/api/tasks/{task_id}/attachments
   * @secure
   */
  addAttachment = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Attachment.
   *
   * @tags Tasks
   * @name DeleteAttachment
   * @summary Delete Attachment
   * @request DELETE:/api/tasks/{task_id}/attachments/{attachment_id}
   * @secure
   */
  deleteAttachment = (taskId, attachmentId, params = {}) =>
    this.http.request({
      path: `/api/tasks/${taskId}/attachments/${attachmentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  getStageGatesReadiness = (params = {}) =>
    this.http.request({
      path: `/api/tasks/stage-gates`,
      method: "GET",
      query: params,
      secure: true,
      format: "json",
    });
  batchUpdateTasks = (payload, params = {}) =>
    this.http.request({
      path: `/api/tasks/batch`,
      method: "POST",
      body: payload,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
